interface Props {
    size: number,
    perc: number,
}

const Code: React.FC<Props> = ({ perc, size }) => {
    const percentagePoint = 1 / 16;

    const borderRadius = 5;

    return (
        <svg width={size} height={size} viewBox="0 0 472 463" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_8_244)">
                <rect x="4" width="120.313" height="26.25" rx={borderRadius} fill="#FF8A5E" />
                {(perc > 1 * percentagePoint) && <rect x="154.938" width="220.938" height="26.25" rx={borderRadius} fill="#3D6099" />}
                {(perc > 2 * percentagePoint) && <rect x="406.5" width="48.125" height="26.25" rx={borderRadius} fill="#E8F1FF" />}
                {(perc > 3 * percentagePoint) && <rect x="89.3125" y="61.25" width="135.625" height="26.25" rx={borderRadius} fill="#3D6099" />}
                {(perc > 4 * percentagePoint) && <rect x="255.562" y="61.25" width="212.188" height="26.25" rx={borderRadius} fill="#FF8A5E" />}
                {(perc > 5 * percentagePoint) && <rect x="93.6875" y="122.5" width="65.625" height="26.25" rx={borderRadius} fill="#E8F1FF" />}
                {(perc > 6 * percentagePoint) && <rect x="189.938" y="122.5" width="238.438" height="26.25" rx={borderRadius} fill="#3D6099" />}
                {(perc > 7 * percentagePoint) && <rect x="93.6875" y="183.75" width="109.375" height="26.25" rx={borderRadius} fill="#FF8A5E" />}
                {(perc > 8 * percentagePoint) && <rect x="231.5" y="183.75" width="87.5" height="26.25" rx={borderRadius} fill="#3D6099" />}
                {(perc > 9 * percentagePoint) && <rect x="4" y="245" width="161.875" height="26.25" rx={borderRadius} fill="#E8F1FF" />}
                {(perc > 10 * percentagePoint) && <rect x="196.5" y="245" width="109.375" height="26.25" rx={borderRadius} fill="#FF8A5E" />}
                {(perc > 11 * percentagePoint) && <rect x="93.6875" y="306.25" width="207.812" height="26.25" rx={borderRadius} fill="#3D6099" />}
                {(perc > 12 * percentagePoint) && <rect x="329.938" y="306.25" width="87.5" height="26.25" rx={borderRadius} fill="#E8F1FF" />}
                {(perc > 13 * percentagePoint) && <rect x="93.6875" y="367.5" width="172.812" height="26.25" rx={borderRadius} fill="#FF8A5E" />}
                {(perc > 14 * percentagePoint) && <rect x="297.125" y="367.5" width="65.625" height="26.25" rx={borderRadius} fill="#3D6099" />}
                {(perc > 15 * percentagePoint) && <rect x="4" y="428.75" width="72.1875" height="26.25" rx={borderRadius} fill="#E8F1FF" />}
            </g>
            <defs>
                <filter id="filter0_d_8_244" x="0" y="0" width="471.75" height="463" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8_244" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8_244" result="shape" />
                </filter>
            </defs>
        </svg>
    );
};

export default Code;
